import { useState } from "react";
import { pushSettings } from "@/mocks/alarm";

export default function PushSettings() {
  const [channels, setChannels] = useState(pushSettings.channels);
  const [thresholds, setThresholds] = useState(pushSettings.thresholds);
  const [saved, setSaved] = useState(false);

  const toggleChannel = (id: string) => {
    setChannels(prev => prev.map(c => c.id === id ? { ...c, enabled: !c.enabled } : c));
  };

  const updateThreshold = (type: string, value: string) => {
    setThresholds(prev => prev.map(t => t.type === type ? { ...t, threshold: value } : t));
  };

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="space-y-4">
      {/* Push Channels */}
      <div className="bg-white rounded-xl border border-gray-100 p-5">
        <h3 className="text-sm font-bold text-gray-900 mb-4">推送渠道设置</h3>
        <div className="grid grid-cols-5 gap-3">
          {channels.map(ch => (
            <div
              key={ch.id}
              onClick={() => toggleChannel(ch.id)}
              className={`flex flex-col items-center gap-2 p-4 rounded-xl border-2 cursor-pointer transition-all ${
                ch.enabled ? "border-[#E8531A] bg-orange-50" : "border-gray-100 bg-gray-50"
              }`}
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${ch.icon} text-2xl ${ch.enabled ? "text-[#E8531A]" : "text-gray-300"}`}></i>
              </div>
              <span className={`text-xs font-medium whitespace-nowrap ${ch.enabled ? "text-gray-800" : "text-gray-400"}`}>{ch.label}</span>
              <div className={`w-8 h-4 rounded-full transition-colors relative ${ch.enabled ? "bg-[#E8531A]" : "bg-gray-200"}`}>
                <div className={`absolute top-0.5 w-3 h-3 rounded-full bg-white transition-all ${ch.enabled ? "left-4" : "left-0.5"}`}></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Level Rules */}
      <div className="bg-white rounded-xl border border-gray-100 p-5">
        <h3 className="text-sm font-bold text-gray-900 mb-4">告警级别推送规则</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="text-left py-2.5 px-3 text-gray-400 font-medium">告警级别</th>
                {["短信", "APP推送", "语音电话", "邮件", "微信", "自动派单"].map(h => (
                  <th key={h} className="text-center py-2.5 px-3 text-gray-400 font-medium whitespace-nowrap">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {pushSettings.levelRules.map(rule => {
                const levelColors: Record<string, string> = {
                  紧急: "bg-red-100 text-red-700",
                  严重: "bg-orange-100 text-orange-700",
                  警告: "bg-amber-100 text-amber-700",
                  提示: "bg-blue-100 text-blue-700",
                };
                const vals = [rule.sms, rule.app, rule.voice, rule.email, rule.wechat, rule.autoDispatch];
                return (
                  <tr key={rule.level} className="border-b border-gray-50">
                    <td className="py-3 px-3">
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${levelColors[rule.level]}`}>{rule.level}</span>
                    </td>
                    {vals.map((v, i) => (
                      <td key={i} className="py-3 px-3 text-center">
                        <div className="w-5 h-5 flex items-center justify-center mx-auto">
                          <i className={v ? "ri-checkbox-circle-line text-emerald-500 text-base" : "ri-close-circle-line text-gray-200 text-base"}></i>
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Thresholds */}
      <div className="bg-white rounded-xl border border-gray-100 p-5">
        <h3 className="text-sm font-bold text-gray-900 mb-4">告警阈值配置</h3>
        <div className="grid grid-cols-2 gap-3">
          {thresholds.map(t => (
            <div key={t.type} className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
              <div className="flex-1">
                <p className="text-xs font-medium text-gray-700 mb-1">{t.type}</p>
                <div className="flex items-center gap-2">
                  <input
                    value={t.threshold}
                    onChange={e => updateThreshold(t.type, e.target.value)}
                    disabled={!t.editable}
                    className="w-24 px-2 py-1 text-xs border border-gray-200 rounded-lg focus:outline-none focus:border-[#E8531A]/50 disabled:bg-gray-100 disabled:text-gray-400"
                  />
                  <span className="text-xs text-gray-400">{t.unit}</span>
                </div>
              </div>
              {!t.editable && (
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-lock-line text-gray-300 text-sm"></i>
                </div>
              )}
            </div>
          ))}
        </div>
        <button
          onClick={handleSave}
          className="mt-4 w-full py-2.5 bg-[#E8531A] text-white text-sm font-semibold rounded-lg hover:bg-[#d44a15] cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 transition-colors"
        >
          {saved ? (
            <><i className="ri-checkbox-circle-line"></i>保存成功！</>
          ) : (
            <><i className="ri-save-line"></i>保存推送设置</>
          )}
        </button>
      </div>
    </div>
  );
}
